import { render } from "./Mb028.vue?vue&type=template&id=a601581e"
import script from "./Mb028.vue?vue&type=script&lang=js"
export * from "./Mb028.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__